<template>
	<section class="newsletter-section">
		<div class="row">
			<div class="columns column7">
				<h2>{{ header }}</h2>
				<div v-parse-links v-html="content" />
			</div>
			<div class="columns column5">
				<div id="mc_embed_signup">
					<form
						id="mc-embedded-subscribe-form"
						action="https://hotelvelotel.us3.list-manage.com/subscribe/post?u=056c0c149fb38ea6def7428ba&amp;id=a447df55bf&amp;v_id=4605&amp;f_id=0092bfe2f0"
						method="post"
						name="mc-embedded-subscribe-form"
						class="validate newsletter"
						target="_blank"
						novalidate
					>
						<div id="mc_embed_signup_scroll">
							<div class="mc-field-group">
								<input
									id="mce-EMAIL"
									type="email"
									:placeholder="$t('formEmail')"
									value=""
									name="EMAIL"
									class="required email"
									required
								/>
								<input
									id="mc-embedded-subscribe"
									type="submit"
									name="subscribe"
									class="button"
									:value="button"
								/>
							</div>
							<div id="mce-responses" class="clear">
								<div id="mce-error-response" class="response" style="display: none" />
								<div id="mce-success-response" class="response" style="display: none" />
							</div>
							<div style="position: absolute; left: -5000px" aria-hidden="true">
								<input
									type="text"
									name="b_056c0c149fb38ea6def7428ba_a447df55bf"
									tabindex="-1"
									value=""
								/>
							</div>
						</div>
					</form>
				</div>
			</div>
		</div>
	</section>
</template>

<script setup>
defineProps({
	header: { type: String, default: '' },
	content: { type: String, default: '' },
	button: { type: String, default: '' },
});
</script>

<style lang="scss" scoped>
section {
	padding: 75px 0;

	.row {
		display: flex;
		flex-flow: row wrap;
		align-items: center;
		justify-content: space-between;
		overflow: hidden;
	}

	.newsletter {
		background: #eeebeb;

		.mc-field-group {
			display: flex;
			flex-flow: row nowrap;
			padding: 15px;
		}

		input {
			padding: 15px;
			width: 100%;
			border: none;
			background: none;
			margin: 0;

			&.button {
				line-height: 20px;
				border: none;
				background: $cta-color;
				color: #fff;
				cursor: pointer;
				max-width: 40%;

				&:hover {
					background: $cta-color-hover;
					color: #fff;
				}
			}
		}
	}
}

@media (max-width: 900px) {
	section input {
		margin: 0 0 10px;
	}

	.column5 {
		width: 100%;
	}

	section {
		.row {
			.newsletter {
				.mc-field-group {
					flex-flow: column wrap;
					padding: 12px;
				}

				input.button {
					max-width: 100%;
				}
			}
		}
	}
}
</style>
